import Axios from 'axios'
import { API_URL } from '@app/constants/endpoints'

const ENDPOINT = `${API_URL}/api/energy/devices`

const convertDate = (current_time: Date): string => current_time.toISOString()

const fetchDevicesWithEnergies = (current_time: Date, access_token: string, sort: string) => Axios.get(ENDPOINT, {
  params: {
    current_time: convertDate(current_time),
    sort,
  },
  headers: {
    'Access-Token': access_token,
  },
})

export default {
  fetchDevicesWithEnergies,
}
